{
    "teacher": {
        "position": {
            "x": 8,
            "y": 1,
            "z": 1
        },
        "key": "teacher",
        "properties": [
            "flipped"
        ]
    }
}
